<template>
  <div class="container">
    <div class="survey-title mb40 has-text-centered"><span class="highlight-text">When</span> are you most
      likely to use cannabis?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Please select one.</h3>
      <div class="columns justify-content-center">
        <div class="column">
          <div
            class="field is-grouped is-flex-tablet justify-content-center align-items-center is-flex-wrap">
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="timePeriod" value="Morning" class="is-checkradio is-block" id="pref-time-morning" type="radio"
                name="pref-time">
              <label for="pref-time-morning"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-morning.svg" alt="" class="mb10">
                <h4 class="pref-label">Morning</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="timePeriod" value="Afternoon" class="is-checkradio is-block" id="pref-time-afternoon" type="radio"
                name="pref-time">
              <label for="pref-time-afternoon"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-afternoon.svg" alt="" class="mb10">
                <h4 class="pref-label">Afternoon</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="timePeriod" value="Evening" class="is-checkradio is-block" id="pref-time-evening" type="radio"
                name="pref-time">
              <label for="pref-time-evening"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-evening.svg" alt="" class="mb10">
                <h4 class="pref-label">Evening</h4>
              </label>
            </div>
            <div class="control pref-block mr5 ml5 mb10 has-text-centered">
              <input v-model="timePeriod" class="is-checkradio is-block" value="Anytime" id="pref-time-anytime" type="radio"
                name="pref-time">
              <label for="pref-time-anytime"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <img src="@/assets/img/icon-anytime.svg" alt="" class="mb10">
                <h4 class="pref-label">Anytime</h4>
              </label>
            </div>
          </div>
        </div>
      </div>

      </p>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="mr0 is-active"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()"
        class="button is-primary ml40 is-marginless-tablet">Submit</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a href="#" @click.prevent="skip()" class="is-primary">Skip</a>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      timePeriod: '',
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {

    /**
     * Step back
     */
    back() {
      this.setStep(6);
      this.setSurvey({
        flavour: [],
      })
    },
    skip() {
      this.setStep(1);
      this.setSurveyEmpty();
      // go to homepage
      this.$router.push({ name: 'HomePage'})
    },

    /**
     * Next step 
     */
    next() {
      if(this.timePeriod == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please select when are you most likely to use cannabis.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          timePeriod: this.timePeriod
        })
        this.submitSurvey();
      }
    },
    submitSurvey() {
     console.log('Api on procgress');
     this.$router.push({ name: 'HomePage'})
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurveyEmpty: "usersurvey/setSurveyEmpty",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>